import React from "react";
import "../styles/common.css";

function Logo() {
  return (
    <div
      style={{
        textDecoration: "none",
        color: "var(--primary-color)",
        fontSize: "1.5rem",
        fontWeight: "700",
        letterSpacing: "1px",
      }}
    >
      DSHUB
    </div>
  );
}

export default Logo;
